<template>
  <div>
    <header class="header container-fluid">
      <div class="row h-100 align-items-center">
        <div class="col d-flex align-items-center">
          <a class="logo" href="/"><span></span></a>
          <h3>OZG Manager</h3>
        </div>
        
      </div>

  
    </header>
  </div>
</template>

<script>
import config from "../config/config.js";
import axios from "axios";
import moment from "moment";

export default {
  data: () => ({
    navigationsItems: [],
  }),

  mounted() {
    axios
      .get(config.API_URL + "/api/getPagesForStructure/mainNav")
      .then((response) => {
        if (response != undefined) {
          this.navigationsItems = JSON.parse(response.data);
        }
      });
  },

  methods: {
    addNewMainPage() {
      this.$root.$children[0].showBaseModal = true;
      this.$root.$children[0].baseDialogComponentName = "PageDialog";

      this.$root.$children[0].baseDialogData = {};
      this.$root.$children[0].baseDialogData.structureId = 1;
      this.$root.$children[0].baseDialogData.Key = moment().format("X");
    },

    addNewSubPage(parentId) {
      this.$root.$children[0].showBaseModal = true;
      this.$root.$children[0].baseDialogComponentName = "PageDialog";

      this.$root.$children[0].baseDialogData = {};
      this.$root.$children[0].baseDialogData.structureId = 1;
      this.$root.$children[0].baseDialogData.parentId = parentId;
      this.$root.$children[0].baseDialogData.Key = moment().format("X");
    },

    editPage(page) {
      this.$root.$children[0].showBaseModal = true;
      this.$root.$children[0].baseDialogComponentName = "PageDialog";

      this.$root.$children[0].baseDialogData = page;

      this.$root.$children[0].baseDialogData.Key = moment().format("X");
    },

    deletePage(page) {
      let deletePage = confirm("Seite löschen?");

      if (deletePage) {
        axios
          .delete(config.API_URL + "/api/page/" + page.pageId)
          .then((response) => {
            this.$root.$children[0].navComponentKey = moment().format("X");
          });
      }
    },
  },
};
</script>


<style scoped>
</style>